import { createCRUDHook } from './createCRUDHook';
import { FilterOptionModel, JsonPatch, LengthSettingsDto } from 'utils/models';
import { GET_LENGTH_DATA_BY_LENGTH, TLKP_LENGTH_SETTING } from './apiEndPoints';
interface LengthSettingsCustomOperations {
  getLengthSettingsDataByLength: (length: number) => Promise<LengthSettingsDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  LengthSettingsDto,
  LengthSettingsDto[],
  LengthSettingsCustomOperations
>({
  entityName: 'LengthSettings',
  endpoint: TLKP_LENGTH_SETTING,
  customOperations: (auth) => ({
    getLengthSettingsDataByLength: async (
      length: number
    ): Promise<LengthSettingsDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TLKP_LENGTH_SETTING + GET_LENGTH_DATA_BY_LENGTH + `?length=${length}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const LengthSettingsContext = Context;
export const useLengthSettingsManager = useManager;
export const useLengthSettings = useConsumer;
